/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BabylonBtcFinalityProviderDetailInfo } from '../models/BabylonBtcFinalityProviderDetailInfo';
import type { BabylonBtcFinalityProviderListInfo } from '../models/BabylonBtcFinalityProviderListInfo';
import type { BabylonBtcStakerListInfo } from '../models/BabylonBtcStakerListInfo';
import type { BabylonBtcStakingDistributionChartDailyInfo } from '../models/BabylonBtcStakingDistributionChartDailyInfo';
import type { BabylonBtcStakingTransactionListInfo } from '../models/BabylonBtcStakingTransactionListInfo';
import type { BabylonFinalityProviderCountInfo } from '../models/BabylonFinalityProviderCountInfo';
import type { BabylonFinalityProviderSummaryIndicatorInfo } from '../models/BabylonFinalityProviderSummaryIndicatorInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class BabylonFinalityProviderControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns BabylonFinalityProviderSummaryIndicatorInfo OK
     * @throws ApiError
     */
    public getBabylonFinalityProviderIndicatorSummary(): CancelablePromise<BabylonFinalityProviderSummaryIndicatorInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/fp/indicator/summary',
        });
    }

    /**
     * @returns BabylonBtcFinalityProviderDetailInfo OK
     * @throws ApiError
     */
    public getBabylonBtcFinalityProviderList({
        fp,
    }: {
        fp: string,
    }): CancelablePromise<BabylonBtcFinalityProviderDetailInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/fp/btc',
            query: {
                'fp': fp,
            },
        });
    }

    /**
     * @returns BabylonBtcStakingTransactionListInfo OK
     * @throws ApiError
     */
    public getBabylonBtcStakingTransactionListByAddress({
        fp,
        status,
        page = 1,
        size = 25,
    }: {
        fp: string,
        status?: Array<'PENDING' | 'VERIFIED' | 'ACTIVE' | 'UNBONDING' | 'WITHDRAWABLE' | 'WITHDRAWN' | 'UNBONDED' | 'EXPIRED' | 'EXPANDED' | 'SLASHED'>,
        page?: number,
        size?: number,
    }): CancelablePromise<BabylonBtcStakingTransactionListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/fp/btc/staking/transaction/list',
            query: {
                'fp': fp,
                'status': status,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns BabylonBtcStakingDistributionChartDailyInfo OK
     * @throws ApiError
     */
    public getBabylonBtcStakingDailDistributionChart(): CancelablePromise<BabylonBtcStakingDistributionChartDailyInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/fp/btc/staking/distribution/chart/daily',
        });
    }

    /**
     * @returns BabylonBtcStakerListInfo OK
     * @throws ApiError
     */
    public getBabylonBtcStakerListByFinalityProviderPk({
        fp,
        sortField = 'STAKING_VALUE',
        sortDirection = 'DESC',
        page = 1,
        size = 25,
    }: {
        fp: string,
        sortField?: 'STAKING_VALUE' | 'STAKING_COUNT',
        sortDirection?: 'ASC' | 'DESC',
        page?: number,
        size?: number,
    }): CancelablePromise<BabylonBtcStakerListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/fp/btc/staker/list',
            query: {
                'fp': fp,
                'sortField': sortField,
                'sortDirection': sortDirection,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns BabylonBtcFinalityProviderListInfo OK
     * @throws ApiError
     */
    public getBabylonBtcFinalityProviderList1({
        term = '',
        status = 'FINALITY_PROVIDER_STATUS_ACTIVE',
        sortField = 'VOTING_POWER',
        sortDirection = 'DESC',
        page = 1,
        size = 100,
    }: {
        term?: string,
        status?: 'FINALITY_PROVIDER_STATUS_INACTIVE' | 'FINALITY_PROVIDER_STATUS_ACTIVE' | 'FINALITY_PROVIDER_STATUS_JAILED' | 'FINALITY_PROVIDER_STATUS_SLASHED',
        sortField?: 'VOTING_POWER' | 'TOTAL_DELEGATION' | 'DELEGATION_COUNT' | 'STAKER_COUNT',
        sortDirection?: 'ASC' | 'DESC',
        page?: number,
        size?: number,
    }): CancelablePromise<BabylonBtcFinalityProviderListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/fp/btc/list',
            query: {
                'term': term,
                'status': status,
                'sortField': sortField,
                'sortDirection': sortDirection,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns BabylonFinalityProviderCountInfo OK
     * @throws ApiError
     */
    public getBabylonFinalityProviderCount1(): CancelablePromise<BabylonFinalityProviderCountInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/fp/btc/count',
        });
    }

}
